module.exports = __webpack_public_path__ + "static/media/Aitcheson College Old Building (the album of Private J W Linley 1923-1938).aa8b6a9c.jpeg";